import { T } from "@freightsimple/ui-core/Typography/T";
import DynamicSpacer from "@/Shared/Layout/CustomComponents/DynamicSpacer";
import type { ReactNode } from "react";

interface GetStartedScreenLayoutProps {
  pageHeading: ReactNode;
  pageSubheading?: ReactNode | undefined;
  children: ReactNode;
  width?: number | undefined;
}

type GetStartedScreenLayoutImplementationProps = GetStartedScreenLayoutProps & {
  hackPleaseRemove?: void | undefined;
};

function BookShipmentScreenLayoutImplementation_(
  props: GetStartedScreenLayoutImplementationProps,
) {
  return (
    <>
      {/* Max-width, not width: the column gives ground on narrow screens
          instead of forcing a horizontal scroll. */}
      <div className="w-full" style={{ maxWidth: `${props.width || 808}px` }}>
        <div className="flex flex-col items-start">
          <h2 className="mt-1 text-[22px] font-semibold text-foreground">
            {props.pageHeading}
          </h2>
          {props.pageSubheading && (
            <div className="max-w-[608px]">
              <T size="sm" color="muted">
                {props.pageSubheading}
              </T>
            </div>
          )}

          <DynamicSpacer minHeight={8} maxHeight={32} />
          {props.children}
        </div>
      </div>
    </>
  );
}

function BookShipmentScreenLayout(props: GetStartedScreenLayoutProps) {
  return <BookShipmentScreenLayoutImplementation_ {...props} />;
}
export default BookShipmentScreenLayout;
